import type { ServerOfferStatus } from '@yoop/server-model/token-info';
import type { ServerMarketplaceType } from '@yoop/server-model/marketplace';
import { isNilOrEmpty } from '@yoop/util';
import {
  containsOrphanMarketplace,
  containsUnsecuredOfferGroup,
} from '@yoop/util-marketplace/helper';
import { requested } from '@yoop/util-marketplace/predicate';
import isEmpty from 'ramda/src/isEmpty';

export interface RequestedFilterMarketplace {
  type?: ServerMarketplaceType;
  parentMarketplaceId?: string;
  offerGroupInformation?: { activeOffer?: { offerStatus?: ServerOfferStatus } }[];
}

/**
 * Filter to get requested events
 * @param event
 * @param notLost
 */
export const requestedFilter = (
  marketplaces: RequestedFilterMarketplace[] | undefined,
  notLost?: boolean,
): boolean => {
  if (isNilOrEmpty(marketplaces)) {
    return false;
  }

  const validMarketplaces = (marketplaces ?? []).filter(requested);
  if (isEmpty(validMarketplaces)) {
    return false;
  }

  return (
    containsOrphanMarketplace(validMarketplaces) &&
    containsUnsecuredOfferGroup(validMarketplaces, notLost ?? false)
  );
};
